import React from 'react';
import { Link } from 'react-router-dom';
import '../css/Header.css'; // header and footer css

const Footer: React.FC = () => {
  return (
    <footer className="footer background-stripes">
      <ul className="nav-links">
        <li>
          <Link to="/about">About Fat Scientist</Link>
        </li>
        <li>
          <Link to="/terms">Terms of Service</Link>
        </li>
        <li>
          <Link to="/privacy">Privacy Policy</Link>
        </li>
      </ul>
      <p className="legal">Copyright © {new Date().getFullYear()} Productist LLC. All rights reserved.</p>
    </footer>
  );
};

export default Footer;
